<template>  
    <router-link :to=link>
        <div v-if='this.animate' class="nav-title" v-bind:class="{ active: isMenuActive(link) }" 
            data-aos="fade-right"
            :data-aos-duration=1000 
            :data-aos-delay=300*this.position > 
        <div class='dotarrow'></div><div class='title'>{{title}}</div></div>

        <div v-if='!this.animate' class="nav-title" v-bind:class="{ active: isMenuActive(link) }" >
        
        <div class='dotarrow'></div><div class='title'>{{title}}</div></div>
        <br />
    </router-link>

</template>

<script>
    export default {
        name: 'navel',
        props: {
            title: String,
            link: String,
            position: Number,
            animate: Boolean
        },
        methods: {
            isMenuActive(route) { 
                console.log(this.$route.name);
                var currentRoute = '/'+this.$route.name 
                return currentRoute == route ? true : false 
            }
        }
    }
</script>

<style lang='less'>
@import '../less/variables.less';
.nav-title {
    text-transform: uppercase;
    .fmb(85px);
    line-height: 85px;
    display: inline-block;
    cursor: pointer;
    position: relative;
    @media (max-width: 1200px) {
        .fmb(65px);
        line-height: 65px; 
    }
    @media (max-width: 1000px) {
        .fmb(45px);
        line-height: 45px; 
    }    
    @media (max-width: @mobile_width) {
        .fmb(35px); 
    }
    &.active {
        .dotarrow {
            opacity: 1.0;
            left: 0px;
        }
    }
    &:hover {
        .dotarrow {
            opacity: 1;
            left: 0px;
            transition: all 0.5s ease-out;
        }
        .title {
            background-color: rgba(35,62,75,1);
        }
    } 

    .dotarrow {
        position: absolute;
        width: 50px;
        height: 95px;
        margin-left: 20px;
        z-index: 2;
        background-image: url('/images/dotarrow.svg');
        background-size: 60% auto;
        background-position: center center; 
        background-repeat: no-repeat;
        opacity: 0;
        left: -100px;
        @media (max-width: 1200px) {
            width: 50px;
            height: 70px;
      
        }
        @media (max-width: 1000px) {
       
        }    
      
        @media (max-width: @mobile_width) {
         display: none;
        
        }     


    }
    .title {
        color: @c1;
        position: relative;
        padding: 5px 20px;
        padding-left: 80px;
        margin-bottom: 15px;
        background-color: rgba(35,62,75,0.9);
        @media (max-width: @mobile_width) {
            padding: 0px 20px;
            padding-left: 20px;
            margin-bottom: 4px;
            margin-top: 4px;
        }        

    } 
}   
</style>